export default {
  filters: {
    fixedDecimal(value, decimals = 0) {
      if (!value && typeof value !== 'number') return ''
      return value.toFixed(decimals)
    },
  },
}
